// extracted by mini-css-extract-plugin
export default {"metadata__unorganized":"UnorganizedList_metadata__unorganized__D4lKZ"};